import React, { useCallback, useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
const purchases = [{
  name: 'Luciana L.',
  city: 'Salta',
  product: 'Kit Adulto de Rescate™',
  time: 'hace 2 minutos'
}, {
  name: 'Martín R.',
  city: 'Córdoba',
  product: 'Kit + Deck Táctico',
  time: 'hace 4 minutos'
}, {
  name: 'Camila S.',
  city: 'Rosario',
  product: 'Kit Adulto de Rescate™',
  time: 'hace 6 minutos'
}, {
  name: 'Federico G.',
  city: 'Mendoza',
  product: 'Kit + Deck Táctico',
  time: 'hace 8 minutos'
}, {
  name: 'Valentina P.',
  city: 'Buenos Aires',
  product: 'Kit Adulto de Rescate™',
  time: 'hace 11 minutos'
}, {
  name: 'Nicolás D.',
  city: 'Tucumán',
  product: 'Kit + Deck Táctico',
  time: 'hace 13 minutos'
}, {
  name: 'Sofía M.',
  city: 'La Plata',
  product: 'Kit Adulto de Rescate™',
  time: 'hace 15 minutos'
}, {
  name: 'Tomás A.',
  city: 'Neuquén',
  product: 'Kit + Deck Táctico',
  time: 'hace 18 minutos'
}, {
  name: 'Julieta C.',
  city: 'Mar del Plata',
  product: 'Kit Adulto de Rescate™',
  time: 'hace 20 minutos'
}, {
  name: 'Gonzalo F.',
  city: 'San Juan',
  product: 'Kit + Deck Táctico',
  time: 'hace 23 minutos'
}, {
  name: 'Rocío B.',
  city: 'Bahía Blanca',
  product: 'Kit Adulto de Rescate™',
  time: 'hace 25 minutos'
}, {
  name: 'Agustín V.',
  city: 'Resistencia',
  product: 'Kit + Deck Táctico',
  time: 'hace 28 minutos'
}, {
  name: 'Florencia H.',
  city: 'Posadas',
  product: 'Kit Adulto de Rescate™',
  time: 'hace 30 minutos'
}, {
  name: 'Diego T.',
  city: 'Santa Fe',
  product: 'Kit + Deck Táctico',
  time: 'hace 33 minutos'
}, {
  name: 'Carolina E.',
  city: 'Paraná',
  product: 'Kit Adulto de Rescate™',
  time: 'hace 36 minutos'
}];
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const showToast = useCallback(() => {
    setDismissed(false);
    setVisible(true);
    // Auto-hide after 6 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 6000);
    return hideTimer;
  }, []);
  useEffect(() => {
    // Show first toast after 8 seconds
    const initialTimer = setTimeout(() => {
      showToast();
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, [showToast]);
  useEffect(() => {
    if (!visible && !dismissed) {
      // After hiding, wait 45 seconds then show next
      const nextTimer = setTimeout(() => {
        setIndex(prev => (prev + 1) % purchases.length);
        showToast();
      }, 45000);
      return () => clearTimeout(nextTimer);
    }
  }, [visible, dismissed, showToast]);
  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
    // Resume after 45 seconds even if dismissed
    setTimeout(() => {
      setIndex(prev => (prev + 1) % purchases.length);
      setDismissed(false);
      showToast();
    }, 45000);
  };
  const purchase = purchases[index];
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm transition-all duration-500 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-337">
      <div className="bg-surface border border-white/10 rounded-xl p-4 shadow-2xl shadow-black/50" data-id="element-338">
        {/* Header */}
        <div className="flex items-center justify-between mb-3" data-id="element-339">
          <div className="flex items-center gap-2" data-id="element-340">
            <span className="relative flex h-2.5 w-2.5" data-id="element-341">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" data-id="element-342"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-gold" data-id="element-343"></span>
            </span>
            <span className="text-gold text-xs font-bold uppercase tracking-wider" data-id="element-344">
              COMPRA VERIFICADA
            </span>
          </div>
          <button onClick={handleDismiss} className="text-gray-500 hover:text-white transition-colors p-0.5" aria-label="Cerrar" data-id="element-345">
            <XIcon className="w-4 h-4" data-id="element-346" />
          </button>
        </div>

        {/* Content */}
        <p className="text-white text-sm mb-1" data-id="element-347">
          <span className="font-bold" data-id="element-348">{purchase.name}</span>
          <span className="text-gray-400" data-id="element-349"> de {purchase.city}</span>
        </p>
        <p className="text-gray-300 text-sm" data-id="element-350">
          compró{' '}
          <span className="text-gold font-semibold" data-id="element-351">{purchase.product}</span>
        </p>
        <p className="text-gold/70 text-xs mt-2" data-id="element-352">{purchase.time}</p>
      </div>
    </div>;
}